import React, { useEffect, useState } from 'react'
import bannerImg from "../../../../assets/images/walletbanner.png";
import { Button } from '@mui/material'
import { getApiHeader } from 'utlis/commonfunctions';
import { ThreeDots } from 'react-loader-spinner'
import axios from 'axios';
import swal from 'sweetalert';

const SERVER_URL = process.env.REACT_APP_API_URL;

function AddToWallet({ setWalletPage, getTopupAmount, setRetailerData }) {

  const [disabled, setDisabled] = useState(false)
  const [activeAmount, setActiveAmount] = useState("")
  const [selectNumbers, setSelectNumbers] = useState([])
  const [customAmount, setCustomAmount] = useState("")
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null)

  getTopupAmount(customAmount || activeAmount)

  const styles = {
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(1px)",
      zIndex: 9999,
    },
  };








  useEffect(() => {
    handleNumber()

  }, [])





  const handleNumber = async () => {
    try {
      setLoading(true)
      const header = await getApiHeader();
      const response = await axios.get(`${SERVER_URL}wallet/amount-list`, { headers: header });
      if (response.status === 200) {
        setLoading(false)
        setSelectNumbers(response.data.data.amounts)
        setData(response?.data?.data)
        setRetailerData(response?.data?.data?.personal_info)
        console.log("response?.data?.data?.personal_info", response?.data?.data?.personal_info)

      }

    } catch (error) {
      setLoading(false)
    }
  };


  const handleCustomAmount = (event) => {

    const { name, value } = event.target
    const isValid = /^\d+$/.test(value) || value === '';
    if (isValid) {
      const numericValue = value.replace(/[^0-9]/g, "");
      setCustomAmount(numericValue)
    }
    setActiveAmount("")
  }




  const handleNext = async () => {
    if ((customAmount && customAmount < 50) || (activeAmount && activeAmount < 50)) {
      swal("", "Amount must be greater than $50.", 'warning');
      return;
    }

    if (!customAmount && !activeAmount) {
      swal("", "Please add an amount to continue.", "warning");
      return;
    }
    setWalletPage(true);
    localStorage.setItem("SelectedWalletAmount",customAmount||activeAmount)
    // swal("", "Wallet Amount Added Successfully.", "success").then(() => {
    // });

  };

  const handleAmountClick = (amount) => {
    setActiveAmount(amount);
    localStorage.setItem('SelectedWalletAmount', amount);
    setCustomAmount("")
  };


  const totalAmount = (Number(customAmount) + Number(activeAmount)).toFixed(2)

   let walletValue
  useEffect(()=>{
    walletValue=localStorage.getItem("SelectedWalletAmount")
     if(walletValue){
      setActiveAmount(walletValue)
     }
  },[])
  

  return (
    <div>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      <div className="container-fluid ">
        {/* Header Section */}
        <section id="hero-2" className="hero-2 d-flex align-items-center">
          <div className="container-fluid">
            <div className="hero-border">

              <div className="hero-background">
                <img src={bannerImg} alt="" className="img-fluid banner-img" style={{ borderRadius: "52px", objectFit: "cover" }} />
              </div>

            </div>
          </div>
        </section>


        {/* Main Section */}
        <div className="row">
          {/* Top-up Options */}
          <div className="col-md-12 col-lg-8">
            <div className="formbold-form-wrapper">
              <h5>Select a top-up amount (AUD)</h5>
              <div className="p-4">

                <div className="d-flex justify-content-center">
                  <div className="d-flex flex-wrap gap-3 mb-3 col-lg-6 justify-content-center">
                    {selectNumbers.map(({ wallet_amount_id, amount }) => (
                      <button
                        style={{ margin: '2px' }}
                        key={wallet_amount_id}
                        className={`btn wrapper-amount-button px-4 py-2 ${activeAmount == String(amount) ? 'active' : '' }`}
                      onClick={() => handleAmountClick(amount)}
                      >
                        ${amount}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Custom Amount */}
                <label htmlFor="customAmount" className="form-label">
                  Enter a Custom Amount:
                </label>
                <div className="d-flex align-items-center">
                  <input
                    type="text"
                    className="form-control me-2"
                    placeholder="AUD"
                    onChange={(e) => handleCustomAmount(e)}
                    maxLength={6}
                    value={customAmount || activeAmount}
                  />
                  <div textAlign="center" mt={4}>
                    <Button
                      variant="outlined"
                      disabled={disabled}
                      sx={{
                        backgroundColor: '#C11D6C',
                        color: '#fff',
                        // width: { xs: '100%', sm: '440px' },
                        width: '150px',
                        '&:hover': {
                          backgroundColor: '#9C1554',
                        },
                      }}
                      onClick={handleNext}
                    >
                      Add To Wallet
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recharge Information */}
          <div className="col-md-12 col-lg-4 mt-2">
            <div className="formbold-form-wrapper">
              <div className="text-center ">
                <h4
                  className=""
                  style={{
                    letterSpacing: '1px',
                    display: 'inline-block',
                  }}
                >
                  Wallet Information
                </h4>
              </div>
              <div className="p-4">
                <div style={{ display: 'block', flexWrap: 'wrap' }} className="mb-2">
                  <strong>Last Recharge Date: </strong>
                 <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }} className="last-recharge-date">{data?.last_purchase_date}</span>
                </div>
                <div className="mb-2">
                  <strong>Current Balance: </strong>
                  <span className="ml-2">${data?.wallet_balance}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddToWallet